export default class WebglProgram {
  constructor(vertexShaderText, fragmentShaderText) {
    this.vertexShaderText = vertexShaderText;
    this.fragmentShaderText = fragmentShaderText;

    this.program = null;
    // main texture and transformation locations
    this.positionLocation = null;
    this.texcoordLocation = null;
    this.matrixLocation = null;
    this.textureLocation = null;
  }

  createProgram(gl){
    this.program  = gl.createProgram();
    this.createShaders(gl);
    this.prepareLocations(gl);
  }

  createShaders(gl) {
    const vertexShader = this.createShader(gl, this.vertexShaderText);
    gl.attachShader(this.program, vertexShader);
    const fragmentShader = this.createShader(gl, this.fragmentShaderText, false);
    gl.attachShader(this.program, fragmentShader);
    gl.linkProgram(this.program);
    if (!gl.getProgramParameter(this.program, gl.LINK_STATUS))
      throw "failed to link program: " + gl.getProgramInfoLog(this.program);
  }
  
  createShader(gl, text, isVertex = true){
    const shaderType = isVertex ? gl.VERTEX_SHADER : gl.FRAGMENT_SHADER;
    const shader = gl.createShader(shaderType);
    gl.shaderSource(shader, text);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS))
      throw "failed to compile shader: " + gl.getShaderInfoLog(shader);
    return shader;
  }

  prepareLocations(gl) {
    // prepate program attribute locations
    this.positionLocation = gl.getAttribLocation(this.program, "a_position");
    this.texcoordLocation = gl.getAttribLocation(this.program, "a_texcoord");
    this.matrixLocation = gl.getUniformLocation(this.program, "u_matrix");
    this.textureLocation = gl.getUniformLocation(this.program, "u_texture");
  }
  
  setSamplerLocation(gl, imageTexture) {
    gl.uniform1i(this.textureLocation, 0);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, imageTexture);
  }

  bindTextureBuffers(gl, positionBuffer, texcoordBuffer){
    // Setup the attributes to pull data from our buffers
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.enableVertexAttribArray(this.positionLocation);
    gl.vertexAttribPointer(this.positionLocation, 2, gl.FLOAT, false, 0, 0);
    gl.bindBuffer(gl.ARRAY_BUFFER, texcoordBuffer);
    gl.enableVertexAttribArray(this.texcoordLocation);
    gl.vertexAttribPointer(this.texcoordLocation, 2, gl.FLOAT, false, 0, 0);
  }

  setTransformationMatrix(gl, matrix) {
    gl.uniformMatrix4fv(this.matrixLocation, false, matrix);
  }

  clearReferences(gl, positionBuffer, coordBuffer, texture) {
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, 1, gl.STATIC_DRAW);
    gl.deleteBuffer(positionBuffer);

    gl.bindBuffer(gl.ARRAY_BUFFER, coordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, 1, gl.STATIC_DRAW);
    gl.deleteBuffer(coordBuffer);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);

    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.deleteTexture(texture);

    gl.deleteProgram(this.program);
  }
}